import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { Upload, Eye, Trash2, Image } from 'lucide-react';
import { COMPANY } from '../../../config/company';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const ClientPhotosTab = ({
  language,
  client,
  photoInputRef,
  uploadingPhoto,
  handleUploadPhotoBulk,
  handleDeletePhoto
}) => {
  return (
    <Card className="bg-white border-gray-200">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-gray-900">{language === 'es' ? 'Fotos' : 'Photos'}</CardTitle>
        <div>
          <input 
            type="file" 
            ref={photoInputRef} 
            onChange={handleUploadPhotoBulk} 
            className="hidden" 
            accept=".jpg,.jpeg,.png,.gif,.webp,.heic,image/*" 
            multiple 
          />
          <Button onClick={() => photoInputRef.current?.click()} disabled={uploadingPhoto} style={{ backgroundColor: COMPANY.primaryColor }} className="text-white">
            <Upload className="mr-2 h-4 w-4" />{uploadingPhoto ? '...' : (language === 'es' ? 'Subir Fotos' : 'Upload Photos')}
          </Button>
          <p className="text-xs text-gray-500 mt-1">{language === 'es' ? 'Hasta 5 fotos (JPG, PNG)' : 'Up to 5 photos (JPG, PNG)'}</p>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {client.photos?.map(photo => (
            <div key={photo.id} className="relative group border rounded-lg overflow-hidden">
              <img 
                src={photo.gridfs_id ? `${BACKEND_URL}/api/files/gridfs/${photo.gridfs_id}` : `${BACKEND_URL}/api/uploads/photos/${photo.filename}`} 
                alt={photo.title}
                className="w-full h-40 object-cover"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="gray" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>';
                }}
              />
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center space-x-2">
                <a href={photo.gridfs_id ? `${BACKEND_URL}/api/files/gridfs/${photo.gridfs_id}` : `${BACKEND_URL}/api/uploads/photos/${photo.filename}`} target="_blank" rel="noreferrer">
                  <Button size="sm" variant="secondary"><Eye className="h-4 w-4" /></Button>
                </a>
                <Button size="sm" variant="destructive" onClick={() => handleDeletePhoto(photo.id)}><Trash2 className="h-4 w-4" /></Button>
              </div>
              <div className="p-2 bg-white">
                <p className="text-gray-900 text-sm font-medium truncate">{photo.title}</p>
                {photo.description && (
                  <p className="text-gray-500 text-xs mt-1 line-clamp-2">{photo.description}</p>
                )}
              </div>
            </div>
          ))}
          {!client.photos?.length && (
            <div className="col-span-full text-center py-8">
              <Image className="h-12 w-12 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-500">{language === 'es' ? 'Sin fotos' : 'No photos yet'}</p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default ClientPhotosTab;
